import { getCommonWidget } from '../../dashWidgetHelper'
import { commonWidgets, NETPAY_COLORS_NPS, NETPAY_SCALE_3_COLORS } from '../commonWidgetsNetpay'
import { List } from 'immutable';

// --------------------------------------------------------
// 1. DICCIONARIOS DE MOTIVOS
// --------------------------------------------------------
const MAP_LABELS_MOTIVO_PROMOTORES: { [key: number]: string } = {
    101: "Rapidez para crear link", 102: "Fácil y amigable", 103: "Confianza de clientes", 104: "Depósito de ventas", 105: "Aceptación de tarjetas", 106: "Reportería", 107: "Servicio Call Center", 108: "Servicio socio comercial", 109: "Beneficios NetPay",
    201: "Automatización de cobros", 202: "Panel de control claro", 203: "Reintentos automáticos", 204: "Alta de nuevos planes", 205: "Depósito de ventas", 206: "Aceptación de tarjetas", 207: "Reportería", 208: "Servicio Call Center", 209: "Servicio socio comercial", 210: "Beneficios NetPay",
    301: "Estabilidad del sistema", 302: "Seguridad y prevención", 303: "Amplia aceptación", 304: "Depósito de ventas", 305: "Aceptación de tarjetas", 306: "Reportería", 307: "Servicio Call Center", 308: "Servicio socio comercial", 309: "Beneficios NetPay"
};

const MAP_LABELS_MOTIVO_DETRACTORES: { [key: number]: string } = {
    101: "Personalización en link", 102: "Velocidad no esperada", 103: "Depósito de ventas", 104: "Comisiones", 105: "Fallas al generar link", 106: "Reportería", 107: "Calidad Call Center", 108: "Socio / Asesor Comercial", 109: "Modificación de datos", 110: "Diseño poco personalizable",
    201: "Notificaciones a clientes", 202: "Cancelación manual", 203: "Reportería", 204: "Comisiones", 205: "Dificultad editar planes", 206: "Calidad Call Center", 207: "Socio / Asesor Comercial", 208: "Modificación de datos", 209: "Cambio de tarjeta complicado",
    301: "Diseño poco personalizable", 302: "Pocas librerías o SDKs", 303: "Sandbox limitado", 304: "Errores en la API", 305: "Falta de soporte técnico", 306: "Demasiados pasos (fricción)", 307: "Panel difícil de navegar"
};

const MAP_LABELS_SUBMOTIVO_ECOMMERCE_PROMOTORES: { [key: string]: { [key: number]: string } } = {
    DEPOSITO_VENTAS: {
        101: "Puntualidad en el depósito de mis ventas", 201: "Puntualidad en el depósito de mis ventas", 301: "Puntualidad en el depósito de mis ventas",
        102: "Claridad en los depósitos de mis ventas", 202: "Claridad en los depósitos de mis ventas", 302: "Claridad en los depósitos de mis ventas",
    },
    REPORTERIA: {
        103: "Velocidad de descarga", 203: "Velocidad de descarga", 303: "Velocidad de descarga",
        104: "Relevancia de la información", 204: "Relevancia de la información", 304: "Relevancia de la información",
    },
    CALIDAD_SERVICIO_CALL_CENTER: {
        105: "Amabilidad y empatía", 205: "Amabilidad y empatía", 305: "Amabilidad y empatía",
        106: "Atención rápida", 206: "Atención rápida", 306: "Atención rápida",
    },
    CALIDAD_SERVICIO_SOCIO_COMERCIAL: {
        107: "Seguimiento puntual", 207: "Seguimiento puntual", 307: "Seguimiento puntual",
        108: "Comunicación", 208: "Comunicación", 308: "Comunicación",
    },
    BENEFICIOS_NETPAY: {
        109: "Acceso al portal Manager", 209: "Acceso al portal Manager", 309: "Acceso al portal Manager",
        110: "Integraciones personalizadas", 210: "Integraciones personalizadas", 310: "Integraciones personalizadas",
        111: "Funcionalidad general", 211: "Funcionalidad general", 311: "Funcionalidad general",
        112: "Confianza en servicio", 212: "Confianza en servicio", 312: "Confianza en servicio",
        113: "Cercanía para atender", 213: "Cercanía para atender", 313: "Cercanía para atender",
    }
};

const MAP_LABELS_SUBMOTIVO_ECOMMERCE_DETRACTORES: { [key: string]: { [key: number]: string } } = {
    DEPOSITO_VENTAS: {
        101: "No veo el depósito reflejado", 102: "No me han depositado", 103: "Se abonó tarde", 104: "No concilia mi depósito",
    },
    COMISIONES: {
        105: "La tasa no es competitiva", 206: "La tasa no es competitiva",
        106: "La tasa no es la pactada", 207: "La tasa no es la pactada",
    },
    FALLAS_LINK: {
        107: "Tarda en generarse", 108: "No se genera", 109: "Error al generar",
    },
    REPORTERIA: {
        110: "Velocidad de descarga", 201: "Velocidad de descarga",
        111: "Relevancia de la información", 202: "Relevancia de la información",
        112: "Históricos de información", 203: "Históricos de información",
        113: "Capacidad de integración", 204: "Capacidad de integración",
        114: "Reportes a la medida", 205: "Reportes a la medida",
    },
    CALL_CENTER: {
        115: "Insatisfecho con el agente", 208: "Insatisfecho con el agente",
        116: "Información incorrecta", 209: "Información incorrecta",
        117: "No se resolvió solicitud", 210: "No se resolvió solicitud",
    },
    SOCIO_COMERCIAL: {
        118: "Falta de comunicación", 211: "Falta de comunicación",
        119: "Falta de seguimiento", 212: "Falta de seguimiento",
        120: "Servicio no adecuado", 213: "Servicio no adecuado",
    },
    MODIFICACION_DATOS: {
        121: "Proceso complicado", 214: "Proceso complicado",
        122: "Proceso demoró mucho", 215: "Proceso demoró mucho",
        123: "Rechazaron documentación", 216: "Rechazaron documentación",
    }
};

const DIVERSE_PALETTE = [
    '#f5a524', '#e74c5c', '#8CF0EA', '#F3AF5A', '#B29BC2', '#F3B6D8', '#FFF9B1',
    '#34C0B8', '#FFD01B', '#F5B49F', '#777933', '#A668A8', '#9A9CCD', '#C0CB0B',
    '#878972', '#0C84AD'
];

// --------------------------------------------------------
// FUNCIÓN HELPER
// --------------------------------------------------------
const mapWithLabels = (data: any, dict?: Record<string, string>) => {
    if (!Array.isArray(data)) return [];

    const fallbackDict: Record<string, string> = {
        "5": "5 - Muy fácil / Muy satisfecho", "4": "4", "3": "3",
        "2": "2", "1": "1 - Nada fácil / Muy insatisfecho", "0": "0 - NS / NC",
        "Sí": "Sí", "No": "No"
    };

    return data.map((item: any, index: number, array: any[]) => {
        const keyCandidate = item.groupId ?? item.groupName ?? item.value ?? item.name;
        const key = keyCandidate !== undefined && keyCandidate !== null ? String(keyCandidate).trim() : '';

        let labelText = key;

        if (dict && dict[key]) {
            labelText = dict[key];
        } else if (fallbackDict[key]) {
            labelText = fallbackDict[key];
        } else if (item.groupName && String(item.groupName).trim() !== '') {
            labelText = String(item.groupName);
        }

        if (!labelText || labelText === 'undefined') labelText = `Sin respuesta`;

        const count = item.count !== undefined ? item.count : 0;

        let finalValue = item.value;
        if (array.length === 1) {
            finalValue = 100;
        } else if (finalValue === undefined) {
            finalValue = count;
        }

        return {
            ...item,
            value: finalValue,
            groupName: labelText,
            label: count > 0 ? `${labelText} (${count})` : labelText
        };
    });
};

const getMotivoWidgetEcommerce = (title: string, indicator: string, mapLabels: any, minId: number, maxId: number) => {
    return getCommonWidget({
        commonWidgets: commonWidgets,
        name: 'pieGenericMedium',
        title,
        size: [2, 3],
        indicator,
        mapper: (data: any) => {
            if (!Array.isArray(data)) return [];
            const safeData = [...data]
                .filter((a: any) => a.groupId >= minId && a.groupId <= maxId)
                .sort((a: any, b: any) => a.groupId - b.groupId);

            const mappedData = mapWithLabels(safeData, mapLabels);

            const mergedData = mappedData.reduce((acc: any, item: any) => {
                const labelText = item.groupName;
                if (!acc[labelText]) {
                    acc[labelText] = { ...item, count: 0, groupName: labelText };
                }
                acc[labelText].count += item.count;
                return acc;
            }, {});

            return Object.values(mergedData).map((item: any) => ({
                ...item,
                label: `${item.groupName} (${item.count})`
            }));
        },
        extraConfigs: { colors: DIVERSE_PALETTE }
    });
};

const getPieSubmotivoEcommerce = (indicator: string, title: string, mapLabels: { [key: number]: string }, minId: number, maxId: number) => {
    return getCommonWidget({
        commonWidgets: commonWidgets,
        name: 'pieGenericMedium',
        title,
        size: [2, 2],
        indicator,
        mapper: (data: any) => {
            // 1. Filtrar solo los IDs que existen en este submotivo
            const filteredData = [...data].filter((a: any) =>
                (a.groupId in mapLabels) && (a.groupId >= minId) && (a.groupId <= maxId)
            );

            // 2. Fusionar contadores de Link, Loop y Checkout si tienen el mismo texto
            const mergedData = filteredData.reduce((acc: any, item: any) => {
                const labelText = mapLabels[item.groupId];
                if (!acc[labelText]) {
                    acc[labelText] = { ...item, count: 0, labelText };
                }
                acc[labelText].count += item.count;
                return acc;
            }, {});

            // 3. Formatear para la gráfica (¡Tipado estricto para que TS no llore!)
            const finalArray = Object.values(mergedData) as any[];
            const total: number = finalArray.reduce((sum: number, item: any) => sum + item.count, 0);

            return finalArray.map((item: any) => ({
                ...item,
                value: total > 0 ? (item.count / total) * 100 : 0,
                label: `${item.labelText} (${item.count})`,
            }));
        },
        extraConfigs: {
            colors: NETPAY_COLORS_NPS,
        }
    });
};

export default {
    title: 'NPS E-Commerce',
    description: 'Dashboard de resultados NPS E-Commerce',
    backgroundClassName: (filters: any) => 'epsilon-hero-bg',
    widgets: (filters: any, filtersData: Record<string, any>) => {
        return [

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'multipleTrendByMonth',
                title: 'NPS',
                size: [2, 2],
                key: 'nps-multiple-trend-by-month',
                indicator: 'np_nps_recomiendacion_netpay',
                mapper: (data: any) => {
                    if (!Array.isArray(data)) return [];
                    return data.map((item: any) => {
                        const val = item.value !== undefined ? item.value : (item.count || 0);
                        return {
                            ...item,
                            groupName: item.groupName + ' (' + val + ')',
                        };
                    });
                },
                extraConfigs: {
                    colors: NETPAY_COLORS_NPS,
                    useCurrent: 0,
                    categories: ['promoters', 'passives', 'detractors'],
                    categoriesLabel: ['Promotores', 'Neutros', 'Detractores'],
                }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'semicircleGeneric',
                title: 'Composición NPS',
                key: 'nps-por-mes',
                size: [2, 2],
                indicator: 'np_nps_recomiendacion_netpay',
                extraConfigs: {
                    colors: NETPAY_SCALE_3_COLORS,
                    categories: ['promoters', 'passives', 'detractors'],
                    useEmojis: false,
                    useCurrent: 0
                },
            }),



            // -----------------------------------------------------------
            // EXPERIENCIA DE INTEGRACIÓN
            // -----------------------------------------------------------
            { title: 'EXPERIENCIA DE INTEGRACIÓN', type: 'label', size: [4, 1], config: { color: '#B7AADC' } },

            getCommonWidget({
                commonWidgets,
                name: 'pieGenericMedium',
                title: '¿Qué tan fácil fue integrarme?',
                size: [2, 2],
                key: 'facilidad-integracion',
                indicator: 'np_nps_ecommerce_facilidad_integracion',
                extras: { formula: 'count-number' },
                mapper: (data: any) => mapWithLabels(data, { "1": "1 - Nada fácil / Muy insatisfecho", "2": "2", "3": "3", "4": "4", "5": "5 - Muy fácil / Muy satisfecho", "0": "0 - NS / NC" }),
                extraConfigs: { colors: NETPAY_COLORS_NPS }
            }),

            getCommonWidget({
                commonWidgets,
                name: 'pieGenericMedium',
                title: '¿Cómo evaluaría su satisfacción con el Servicio de integración?',
                size: [2, 2],
                key: 'servicio-integracion',
                indicator: 'np_nps_ecommerce_servicio_integracion',
                extras: { formula: 'count-number' },
                mapper: (data: any) => mapWithLabels(data, { "1": "1 - Nada fácil / Muy insatisfecho", "2": "2", "3": "3", "4": "4", "5": "5 - Muy fácil / Muy satisfecho", "0": "0 - NS / NC" }),
                extraConfigs: { colors: NETPAY_COLORS_NPS }
            }),

            getCommonWidget({
                commonWidgets,
                name: 'pieGenericMedium',
                title: '¿Cuenta con la documentación completa?',
                size: [2, 2],
                key: 'documentacion-completa',
                indicator: 'np_nps_ecommerce_documentacion',
                extras: { formula: 'count-number' },
                mapper: (data: any) => mapWithLabels(data, { "1": "Sí", "0": "No" }),
                extraConfigs: { colors: NETPAY_COLORS_NPS }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieGenericMedium',
                title: '¿Sobre qué producto de Ecommerce quieres compartirnos comentarios?',
                size: [2, 2],
                key: 'tipo-producto-ecommerce',
                indicator: 'np_nps_tipo_producto_ecommerce',
                mapper: (data: any) => mapWithLabels(data, { "1": "Link de Pago", "2": "Loop", "3": "Checkout" }),
                extraConfigs: {
                    colors: DIVERSE_PALETTE
                }
            }),

            // -----------------------------------------------------------
            // LINK DE PAGO
            // -----------------------------------------------------------
            { title: '--- LINK DE PAGO ---', type: 'label', size: [4, 1], config: { color: '#B7AADC' } },

            getMotivoWidgetEcommerce('¿Cuál es el principal motivo de tu calificación? (Promotores 9-10)', 'np_nps_motivo_calificacion_ecommerce', MAP_LABELS_MOTIVO_PROMOTORES, 100, 199),
            getMotivoWidgetEcommerce('¿Cuál es el principal motivo de tu calificación? (Detractores y Neutros 0-8)', 'np_nps_motivo_calificacion_ecommerce_detractor', MAP_LABELS_MOTIVO_DETRACTORES, 100, 199),

            { title: 'SUBMOTIVOS DE PROMOTORES', type: 'label', size: [4, 1] },

            getPieSubmotivoEcommerce('np_nps_submotivo_ecommerce', 'Depósito de ventas', MAP_LABELS_SUBMOTIVO_ECOMMERCE_PROMOTORES.DEPOSITO_VENTAS, 100, 199),
            getPieSubmotivoEcommerce('np_nps_submotivo_ecommerce', 'Reportería', MAP_LABELS_SUBMOTIVO_ECOMMERCE_PROMOTORES.REPORTERIA, 100, 199),
            getPieSubmotivoEcommerce('np_nps_submotivo_ecommerce', 'Servicio Call Center', MAP_LABELS_SUBMOTIVO_ECOMMERCE_PROMOTORES.CALIDAD_SERVICIO_CALL_CENTER, 100, 199),
            getPieSubmotivoEcommerce('np_nps_submotivo_ecommerce', 'Servicio socio comercial', MAP_LABELS_SUBMOTIVO_ECOMMERCE_PROMOTORES.CALIDAD_SERVICIO_SOCIO_COMERCIAL, 100, 199),
            getPieSubmotivoEcommerce('np_nps_submotivo_ecommerce', 'Beneficios NetPay', MAP_LABELS_SUBMOTIVO_ECOMMERCE_PROMOTORES.BENEFICIOS_NETPAY, 100, 199),

            { title: 'SUBMOTIVOS DE DETRACTORES Y NEUTROS', type: 'label', size: [4, 1] },

            getPieSubmotivoEcommerce('np_nps_submotivo_ecommerce_detractor', 'Depósito de ventas', MAP_LABELS_SUBMOTIVO_ECOMMERCE_DETRACTORES.DEPOSITO_VENTAS, 100, 199),
            getPieSubmotivoEcommerce('np_nps_submotivo_ecommerce_detractor', 'Comisiones', MAP_LABELS_SUBMOTIVO_ECOMMERCE_DETRACTORES.COMISIONES, 100, 199),
            getPieSubmotivoEcommerce('np_nps_submotivo_ecommerce_detractor', 'Fallas al generar link', MAP_LABELS_SUBMOTIVO_ECOMMERCE_DETRACTORES.FALLAS_LINK, 100, 199),
            getPieSubmotivoEcommerce('np_nps_submotivo_ecommerce_detractor', 'Reportería', MAP_LABELS_SUBMOTIVO_ECOMMERCE_DETRACTORES.REPORTERIA, 100, 199),
            getPieSubmotivoEcommerce('np_nps_submotivo_ecommerce_detractor', 'Calidad Call Center', MAP_LABELS_SUBMOTIVO_ECOMMERCE_DETRACTORES.CALL_CENTER, 100, 199),
            getPieSubmotivoEcommerce('np_nps_submotivo_ecommerce_detractor', 'Socio / Asesor Comercial', MAP_LABELS_SUBMOTIVO_ECOMMERCE_DETRACTORES.SOCIO_COMERCIAL, 100, 199),
            getPieSubmotivoEcommerce('np_nps_submotivo_ecommerce_detractor', 'Modificación de datos', MAP_LABELS_SUBMOTIVO_ECOMMERCE_DETRACTORES.MODIFICACION_DATOS, 100, 199),


            // -----------------------------------------------------------
            // LOOP
            // -----------------------------------------------------------
            { title: '--- LOOP ---', type: 'label', size: [4, 1], config: { color: '#B7AADC' } },

            getMotivoWidgetEcommerce('¿Cuál es el principal motivo de tu calificación? (Promotores 9-10)', 'np_nps_motivo_calificacion_ecommerce', MAP_LABELS_MOTIVO_PROMOTORES, 200, 299),
            getMotivoWidgetEcommerce('¿Cuál es el principal motivo de tu calificación? (Detractores y Neutros 0-8)', 'np_nps_motivo_calificacion_ecommerce_detractor', MAP_LABELS_MOTIVO_DETRACTORES, 200, 299),

            { title: 'SUBMOTIVOS DE PROMOTORES', type: 'label', size: [4, 1] },

            getPieSubmotivoEcommerce('np_nps_submotivo_ecommerce', 'Depósito de ventas', MAP_LABELS_SUBMOTIVO_ECOMMERCE_PROMOTORES.DEPOSITO_VENTAS, 200, 299),
            getPieSubmotivoEcommerce('np_nps_submotivo_ecommerce', 'Reportería', MAP_LABELS_SUBMOTIVO_ECOMMERCE_PROMOTORES.REPORTERIA, 200, 299),
            getPieSubmotivoEcommerce('np_nps_submotivo_ecommerce', 'Servicio Call Center', MAP_LABELS_SUBMOTIVO_ECOMMERCE_PROMOTORES.CALIDAD_SERVICIO_CALL_CENTER, 200, 299),
            getPieSubmotivoEcommerce('np_nps_submotivo_ecommerce', 'Servicio socio comercial', MAP_LABELS_SUBMOTIVO_ECOMMERCE_PROMOTORES.CALIDAD_SERVICIO_SOCIO_COMERCIAL, 200, 299),
            getPieSubmotivoEcommerce('np_nps_submotivo_ecommerce', 'Beneficios NetPay', MAP_LABELS_SUBMOTIVO_ECOMMERCE_PROMOTORES.BENEFICIOS_NETPAY, 200, 299),

            { title: 'SUBMOTIVOS DE DETRACTORES Y NEUTROS', type: 'label', size: [4, 1] },

            getPieSubmotivoEcommerce('np_nps_submotivo_ecommerce_detractor', 'Comisiones', MAP_LABELS_SUBMOTIVO_ECOMMERCE_DETRACTORES.COMISIONES, 200, 299),
            getPieSubmotivoEcommerce('np_nps_submotivo_ecommerce_detractor', 'Reportería', MAP_LABELS_SUBMOTIVO_ECOMMERCE_DETRACTORES.REPORTERIA, 200, 299),
            getPieSubmotivoEcommerce('np_nps_submotivo_ecommerce_detractor', 'Calidad Call Center', MAP_LABELS_SUBMOTIVO_ECOMMERCE_DETRACTORES.CALL_CENTER, 200, 299),
            getPieSubmotivoEcommerce('np_nps_submotivo_ecommerce_detractor', 'Socio / Asesor Comercial', MAP_LABELS_SUBMOTIVO_ECOMMERCE_DETRACTORES.SOCIO_COMERCIAL, 200, 299),
            getPieSubmotivoEcommerce('np_nps_submotivo_ecommerce_detractor', 'Modificación de datos', MAP_LABELS_SUBMOTIVO_ECOMMERCE_DETRACTORES.MODIFICACION_DATOS, 200, 299),


            // -----------------------------------------------------------
            // CHECKOUT
            // -----------------------------------------------------------
            { title: '--- CHECKOUT ---', type: 'label', size: [4, 1], config: { color: '#B7AADC' } },

            getMotivoWidgetEcommerce('¿Cuál es el principal motivo de tu calificación? (Promotores 9-10)', 'np_nps_motivo_calificacion_ecommerce', MAP_LABELS_MOTIVO_PROMOTORES, 300, 399),
            getMotivoWidgetEcommerce('¿Cuál es el principal motivo de tu calificación? (Detractores y Neutros 0-8)', 'np_nps_motivo_calificacion_ecommerce_detractor', MAP_LABELS_MOTIVO_DETRACTORES, 300, 399),

            { title: 'SUBMOTIVOS DE PROMOTORES', type: 'label', size: [4, 1] },

            getPieSubmotivoEcommerce('np_nps_submotivo_ecommerce', 'Depósito de ventas', MAP_LABELS_SUBMOTIVO_ECOMMERCE_PROMOTORES.DEPOSITO_VENTAS, 300, 399),
            getPieSubmotivoEcommerce('np_nps_submotivo_ecommerce', 'Reportería', MAP_LABELS_SUBMOTIVO_ECOMMERCE_PROMOTORES.REPORTERIA, 300, 399),
            getPieSubmotivoEcommerce('np_nps_submotivo_ecommerce', 'Servicio Call Center', MAP_LABELS_SUBMOTIVO_ECOMMERCE_PROMOTORES.CALIDAD_SERVICIO_CALL_CENTER, 300, 399),
            getPieSubmotivoEcommerce('np_nps_submotivo_ecommerce', 'Servicio socio comercial', MAP_LABELS_SUBMOTIVO_ECOMMERCE_PROMOTORES.CALIDAD_SERVICIO_SOCIO_COMERCIAL, 300, 399),
            getPieSubmotivoEcommerce('np_nps_submotivo_ecommerce', 'Beneficios NetPay', MAP_LABELS_SUBMOTIVO_ECOMMERCE_PROMOTORES.BENEFICIOS_NETPAY, 300, 399),

            // (Checkout no tiene Submotivos de Detractores configurados en la encuesta)


            // -----------------------------------------------------------
            // ETIQUETAS DE SENTIMIENTO Y COMENTARIOS
            // -----------------------------------------------------------
            { title: 'ANÁLISIS DE SENTIMIENTOS Y COMENTARIOS', type: 'label', size: [4, 1], config: { color: '#B7AADC' } },

            // --- 1. Análisis de Sentimientos Global ---
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'textAnalysis',
                size: [4, 2],
                key: 'analisis-sentimientos-nlp',
                indicator: 'sentiment',
                extraConfigs: {
                    colors: NETPAY_SCALE_3_COLORS,
                    typeColumn: 'percent',
                    widgetTitle: 'Etiquetas de Sentimientos',
                    groupKeys: ['positive', 'neutral', 'negative'],
                    groupLabels: { 'positive': 'Promotores', 'neutral': 'Neutros', 'negative': 'Detractores' },
                    defaultHeight: 300,
                },
                mapper: (data: any, extra?: any) => {
                    const actualData = Array.isArray(data) ? data[0] : data;

                    if (!actualData || !actualData.categories) {
                        return { ...actualData, categories: List([]) };
                    }

                    let categories = actualData.categories || [];
                    let sortedCategories = [...categories].sort((a: any, b: any) => b.count - a.count);

                    const splitTags = (item: any[]): any[] => {
                        const tags = [...(item || [])].sort((a: any, b: any) => b.count - a.count);
                        return tags.map((tag: any) => ({
                            ...tag,
                            tags: splitTags(tag.tags),
                        }));
                    };

                    sortedCategories = sortedCategories.map((item: any) => ({
                        ...item,
                        tags: splitTags(item.tags),
                    }));

                    return {
                        ...actualData,
                        categories: List(sortedCategories),
                    }
                },
            }),

            // --- 2. Comentarios: Plug-in ---
            {
                ...getCommonWidget({
                    commonWidgets,
                    name: 'lastComments',
                    title: '¿Otro plug in que no tengamos y te habría gustado?',
                    size: [4, 2],
                    key: 'plugin-comentario',
                    indicator: 'np_nps_ecommerce_plugin_comentario',
                    helpText: '<p>Muestra los comentarios más recientes en formato de tarjeta.</p>',
                    extraConfigs: {
                        maxCommentSize: 200,
                        layout: 'card',
                        showScoreBadge: true,
                        scoreColors: NETPAY_SCALE_3_COLORS,
                        geolocationLabelShow: false,
                    },
                    mapper: (data: any) => {
                        if (typeof document !== 'undefined' && !document.getElementById('ecommerce-comments-auto-height')) {
                            const style = document.createElement('style');
                            style.id = 'ecommerce-comments-auto-height';
                            style.innerHTML = `
                              .ecommerce-auto-height { height: auto !important; }
                              .ecommerce-auto-height .epsilon-widget-card-component { height: auto !important; min-height: 100%; }
                              .ecommerce-auto-height .comments-component--card { height: auto !important; }
                              .ecommerce-auto-height .comments-card-list { max-height: none !important; overflow-y: visible !important; }
                          `;
                            document.head.appendChild(style);
                        }
                        return data;
                    }
                }),
                className: 'ecommerce-auto-height'
            },

            // --- 3. Comentarios: Experiencia General ---
            {
                ...getCommonWidget({
                    commonWidgets: commonWidgets,
                    name: 'lastComments',
                    title: 'Cuéntanos más',
                    size: [4, 2],
                    key: 'comentario-general',
                    indicator: 'np_nps_comentario',
                    helpText: '<p>Muestra los comentarios más recientes en formato de tarjeta.</p>',
                    extraConfigs: {
                        maxCommentSize: 200,
                        layout: 'card',
                        showScoreBadge: true,
                        scoreColors: NETPAY_SCALE_3_COLORS,
                        geolocationLabelShow: false,
                    },
                    mapper: (data: any) => data
                }),
                className: 'ecommerce-auto-height'
            },

            // -----------------------------------------------------------
            // NPS POR SEGMENTO Y GIRO 
            // -----------------------------------------------------------
            { title: 'NPS POR SEGMENTO Y GIRO', type: 'label', size: [4, 1], config: { color: '#B7AADC' } },

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'barByQuestionNps',
                key: 'ecommerce-nps-por-segmento',
                title: 'Resumen segmentado',
                size: [4, 3],
                indicator: 'np_nps_recomiendacion_netpay',
                extras: {
                    formula: 'nps-10',
                    groupByResponseValueId: 29804,
                    groupBy: "responseValue",
                },
                mapper: (data: any) => {
                    return data.map((item: any) => ({
                        ...item,
                        groupName: item.groupName ? item.groupName.trim() : 'No Definido'
                    }));
                },
                extraConfigs: {
                    colors: NETPAY_SCALE_3_COLORS,
                    groupKeys: ['promoters', 'passives', 'detractors'],
                    groupLabels: { 'promoters': 'Promotores', 'passives': 'Neutros', 'detractors': 'Detractores' },
                    decimals: 0,
                    crossFilter: true,
                    enableCrossFilter: true,
                    showCountInLabel: true,
                    showNpsLine: true
                }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'verticalStackedBar',
                key: 'ecommerce-nps-por-giro',
                title: 'NPS por giro',
                size: [4, 3],
                indicator: 'np_nps_recomiendacion_netpay',
                extras: {
                    formula: 'nps-10',
                    groupByResponseValueId: 29803,
                    groupBy: "responseValue",
                },

                mapper: (data: any) => {
                    return data.map((item: any) => ({
                        ...item,
                        groupName: item.groupName ? item.groupName.trim() : 'Otro'
                    }));
                },
                extraConfigs: {
                    isHybridNps: true,
                    colors: { 'volumeHigh': '#00b050', 'volumeMid': '#FFD01B', 'volumeLow': '#ff0000', 'nps': '#0C84AD' },
                    groupLabels: { 'volume': 'Encuestas', 'nps': 'NPS' },
                    decimals: 0,
                    crossFilter: true,
                    enableCrossFilter: true,
                }
            })
        ]
    },
} as DasboardConfig;